export const PUSHER_SUBSCRIPTION_SUCCEEDED = 'pusher:subscription_succeeded';
export const PUSHER_SUBSCRIPTION_ERROR = 'pusher:subscription_error';

export const CONNECT_BROADCAST_SCALES = 'client-connect:broadcast:scales';
export const CONNECT_RESPONSE_SCALE_READ = 'client-connect:response:scale:read';
export const CONNECT_BROADCAST_PRINTERS_SUCCESS = 'client-connect:broadcast:printers';
export const CONNECT_BROADCAST_PRINTERS_FAILURE = 'client-connect:broadcast:malfunction:printers';
export const CONNECT_RESPONSE_PRINTER_JOB = 'client-connect:response:printer:job';

export const CONNECT_AUTO_READ_SCALE_SUCCESS = 'client-connect:auto:scale:reading';
export const CONNECT_AUTO_READ_SCALE_FAILURE = 'client-connect:auto:scale:error';

export const CONNECT_REQUEST_REFRESH = 'connect:request:refresh';
export const CONNECT_REQUEST_SCALE_READ = 'connect:request:scale:read';
export const CONNECT_REQUEST_PRINTER_JOB = 'connect:request:printer:job';

export const SERVER_BULK_ACTION_COST_REVIEW = 'bulk-action:cost-review';

export const SERVER_PAGE_REDIRECT = 'server-page-redirect';
export const SERVER_LOGOUT_AND_REDIRECT = 'server-logout-redirect';
export const SERVER_LOGOUT = 'server-logout';
export const CENTRAL_AUTH_LOGIN = 'central_auth_login';
export const FORCED_SELLER_LOGOUT = 'forced_seller_logout';
export const SELLER_MAINTENANCE_PENDING = 'maintenance_warning_notification';
export const SELLER_MAINTENANCE_IMPENDING = 'maintenance_warning_impending';

export const STORE_REFRESH_STATUS = 'store_status';
/* instant order sync */
export const STORE_REFRESH_STATUS_V2 = 'store_status_v2';

export const DROPIN_EXPIRATION = 'drop_in_expired';

export const V2_IFRAME_STORE_AUTH_REDIRECT = 'client-v3-store:auth:redirect';

export const ADDRESS_UPDATED = 'addresses_updated';
export const BULK_UPDATE_JOB_UPDATE = 'bulk-update';
export const BULK_UPDATE_ADD_TAX_IDS_JOB_STATUS = 'bulk-action-filter:fulfillment-plan-update-tax-ids';
export const BULK_UPDATE_SHIPPING_CONFIGURATION_JOB_COMPLETE = 'bulk-action:shipping-configuration';
export const BULK_UPDATE_SALES_ORDER_JOB_COMPLETE = 'bulk-action:sales-order-update';
export const BULK_UPDATE_TEMPLATE_JOB_COMPLETE = 'bulk-action:fulfillment-plan-template-update';
export const BULK_UPDATE_DO_NOT_NOTIFY_MARKETPLACE_JOB_COMPLETE = 'bulk-action:fulfillment-plan-do-not-notify-marketplace';
export const BULK_ACTION_ADD_WEIGHT = 'bulk-action:add-weight';
export const RATES_UPDATED = 'rates_updated';
/** Streams per-provider rate results from POST /rate/v2/browse. Not the CSW pseudo-fulfillment-plan-id of the same string. */
export const RATE_BROWSER_RESULT = 'rate-browser';
export const BULK_ACTION_SALES_ORDER_CANCEL = 'bulk-action:sales-order-cancel';
export const EXPORT_SHIPMENTS_JOB_COMPLETE = 'export:labelfulfillments';
export const CUSTOM_EXPORT_SHIPMENTS_JOB_COMPLETE = 'export:custom-label-fulfillment';
export const CUSTOM_EXPORT_SHIPMENTS_QUICKSEARCH_JOB_COMPLETE = 'export:custom-shipment-format-quicksearch';
export const EXPORT_SALES_ORDER_JOB_COMPLETE = 'export:salesorders';
export const EXPORT_FULFILLMENT_PLAN_JOB_COMPLETE = 'export:fulfillmentplans';
export const EXPORT_FREIGHT_SHIPMENTS_JOB_COMPLETE = 'export:freightshipments';
export const EXPORT_INVENTORY_JOB_COMPLETE = 'export:inventory';
export const EXPORT_LOCATIONS_INVENTORY_JOB_COMPLETE = 'export:inventory-locations';
export const EXPORT_FULFILLMENT_EXPORT_JOB_COMPLETE = 'export:fulfillments';
export const EXPORT_WALLET_TRANSACTION_HISTORY_JOB_COMPLETE = 'export:wallet-transaction-history';
export const CUSTOM_EXPORT_ORDERS_JOB_COMPLETE = 'export:custom-order-format';
export const CORE_JOBSERVICE_JOB_COMPLETE = 'job_complete';
export const SERVER_STAMPS_VERIFICATION_REQUIRED = 'verification_required';
export const BULK_UPDATE_ADD_NOTE_COMPLETE = 'bulk-action-filter:sales-order-create-note';
export const BULK_UPDATE_SHIP_BY_DATE_COMPLETE = 'bulk-action-filter:sales-order-ship-by-date';
export const BULK_PRINT_PACKING_SLIPS_FALLBACK = 'bulk-print-packing-slips-fallback';

export const UPS_ONE_BALANCE_REGISTRATION_ERROR = 'ups_one_balance_registration_error';
export const UPS_ONE_BALANCE_REGISTRATION_SUCCESS = 'ups_one_balance_registration_success';

export const PRODUCT_DETAILS_APPLY_CHANGES_COMPLETE = 'product:apply-changes-to-open-fulfillmentplans';

export const INVENTORY_ACTION_COMPLETE = 'inventory_action_complete';

export const FULFILLMENTS_CANCELLED = 'fulfillments_cancelled';

export const FULFILLMENTS_UPDATED = 'fulfillments_updated';
export const PRODUCT_IMPORT_JOB_COMPLETE = 'product_import_job_complete';
export const PRODUCT_BUNDLES_IMPORT_JOB_COMPLETE = 'product_bundles_import_job_complete';
export const PRODUCT_IMPORT_V3_JOB_COMPLETE = 'import_products_csv_action';
export const PRODUCT_BUNDLES_IMPORT_V3_JOB_COMPLETE = 'import_product_bundles_csv_action';
export const INVENTORY_IMPORT_JOB_COMPLETE = 'inventory_import_job_complete';
export const CUSTOMER_IMPORT_JOB_COMPLETE = 'customer_import_job_complete';

export const BATCH_VALIDATED = 'batch_validated';

export const LOCAL_DELIVERY_EXCEPTION = 'local-delivery-exception';

export const BULK_PRINT = 'bulk-print';

export const GENERATE_REPORT = 'generate-report';

export const BATCH_PROGRESS = 'batch_progress';

export const FULFILLMENT_PLAN_ITEM_ADJUSTMENT = 'FulfillmentPlanItemAdjustment';

export const ORDER_STATUS_UPDATED = 'order_status_updated';

export const DEACTIVATED_USER = 'deactivated-user';

export const GENERATE_EOD_MESSAGE_ID = 'bulk-action:generateEOD';

export const CSV_PRODUCT_IMPORT_JOB_COMPLETE = 'csv_product_import_job_complete';

export const CSV_DANGEROUS_GOODS_IMPORT_JOB_COMPLETE = 'csv_dangerous_goods_import_job_complete';

export const CSV_PRODUCT_UOM_IMPORT_JOB_COMPLETE = 'csv_product_uom_import_job_complete';

export const CSV_IMPORT_PROGRESS = 'csv-import-progress';

export const BULK_RESHIP_JOB_COMPLETE = 'bulk-action:reshipWorkflow';

export const CSV_ORDER_IMPORT_JOB_COMPLETE = 'csv_order_import_job_complete';

export const CSV_INVENTORY_IMPORT_JOB_COMPLETE = 'inventory_import_job_complete';

export const CSV_INVENTORY_LOCATION_IMPORT_JOB_COMPLETE = 'csv_inventory_location_import_job_complete';

export const CSV_TOTE_IMPORT_JOB_COMPLETE = 'csv_tote_import_job_complete';

export const CSV_TOTE_EXPORT_JOB_COMPLETE = 'export:totes';
export const PURCHASE_ORDER_EXPORT_COMPLETE = 'export:purchaseOrder';

export const CSV_ASN_IMPORT_JOB_COMPLETE = 'csv_asn_import_job_complete';

export const SCAN_TO_RECEIVE_JOB_COMPLETE = 'scan_to_receive_job_complete';

export const CSV_PRODUCT_WITH_INVENTORY_IMPORT_JOB_COMPLETE = 'csv_product_with_inventory_import_job_complete';

export const CSV_PURCHASE_ORDER_IMPORT_JOB_COMPLETE = 'csv_purchase_order_import_job_complete';

export const ALTERNATIVE_RATES_UPDATED = 'bulk-action:alternative-rates';
export const BULK_APPLY_RATE_RECOMMENDATIONS = 'bulk-action:apply-rate-recommendations';

export const SELLER_PROVIDER_APPROVAL_GRANTED = 'sellerProvider-approval-granted';

export const SELLER_IDV_SUCCEEDED = 'seller-idv-succeeded';
export const SELLER_IDV_FAILED = 'seller-idv-failed';
export const SELLER_IDV_PENDING_REVIEW = 'seller-idv-pending-review';
export const SELLER_LOCKOUT = 'seller-lockout';
export const COMPLETE_STORE_ONBOARDING_PUSHER_EVENT_NAME = 'returns-complete-store-onboarding';
export const RECEIVED_USER_TOKEN_WEBHOOK_RESPONSE = 'returns-received-user-token-webhook-response';

export const CANCEL_SHIPMENT_REFUNDS_JOB_COMPLETE = 'bulk-action:cancel-refund';

export const REFRESH_STORE_PRODUCTS = 'refresh-store-products';
export const REFRESH_STORE_INVENTORY = 'refresh-store-inventory';

export const SYNC_PRODUCTS_UPDATED = 'sync-products-to-fulfillment-provider';

export const REPROCESS_OPEN_ORDERS_BATCH = 'reprocess-order-batch';

export const CSV_BLACKLIST_IMPORT_JOB_COMPLETE = 'csv_blacklist_import_job_complete';

export const CSV_SUPPLIER_IMPORT_JOB_COMPLETE = 'csv_supplier_import_job_complete';

export const CSV_FREIGHT_IMPORT_JOB_COMPLETE = 'csv_freight_import_job_complete';

export const CSV_CUSTOM_PACKAGE_IMPORT_JOB_COMPLETE = 'csv_custom_package_import_job_complete';

export const CSV_FREIGHT_COMMODITY_PRESET_IMPORT_JOB_COMPLETE = 'csv_freight_commodity_preset_import_job_complete';

export const CSV_FREIGHT_HANDLING_UNIT_PRESET_IMPORT_JOB_COMPLETE = 'csv_freight_handling_unit_preset_import_job_complete';

export const CUSTOM_PACKAGES_EXPORT_JOB_COMPLETE = 'export:custom-packages';
